<template>
  <div class="container">
      <div class="point-top">
        <div>
          <p>{{Sum?Sum.pointSum:0}}</p>
          <p>积分</p>
        </div>
        <div @click="goIntegral()">
            <span>积分规则</span>
            <img src="../../static/image/userinfo/doubt.png" alt="">
        </div>
      </div>
      <div class="point-detail">
        <div>
          <p style="margin: 0;">积分明细</p>
        </div>
        <div class="points">
         <div v-for="(item,index) in pointData" class="points-item" v-if="pointData">
            <div>
              <p>{{item.dimensionName}}</p>
              <p>{{item.createTime}}</p>
            </div>
            <div>+{{item.score}}</div>
          </div>
          <!-- 引入分页器 -->
          <div class="PagePagination">
            <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
  import PagePagination from "./pagePagination/pagePagination.vue"; //引入分页器
  export default {
    name: "myPoints",
    components: {
      PagePagination,
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total:0,
        pointData:[],  // 积分明细
        Sum:{}
      };
    },
    created() {
       this.getPoints()
    },
    methods: {
      // 去积分规则页面
      goIntegral(){
        this.$router.push({
          path: "/home/richText",
          query:{
            pageType:"justDetail",
            id:7
          }
        });
      },
      // 分页开始
      changePageIndex(page) {
        console.log(page);
        this.pageIndex = page;
        setTimeout(() => {
          this.getPoints();
        }, 100)
      },
      changePageInfo(current, size, total) {
        this.pageIndex = current;
        this.pageSize = size;
        this.total = total

      },
      async getPoints(){  // 积分
         let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        console.log(userInfo)
          try {
            let data = {
              pageNo:this.pageIndex,
              pageSize:this.pageSize,
              designerId:userInfo.id
            }
            console.log(data)
            const res = await this.$http.getPoints(data);
            if (res.code == 200) {
             this.pointData =  res.result?res.result.page.records:[];
             this.Sum = res.result,
              this.changePageInfo(this.pageIndex,res.result.size,res.result.total)
            } else {
              this.$message(res.message);
            }
          } catch (e) {

            throw e
          }
      },
    },


  };
</script>

<style scoped="scoped" lang="less">
    .container{
       width: 900px;
       height: 544px;
       box-sizing: border-box;
    }
    .PagePagination{
      display: flex;
      justify-content: center;
    }
    .point-detail{
      width: 100%;

    }
    .point-detail>div:nth-of-type(1){
      width: 100%;
      height: 42px;
      line-height: 42px;
      padding-left: 45px;
      font-weight: bold;
      font-size: 16px;
      color: #3A3A3A;
      border-bottom: 1px solid #C7C7C7;
      box-sizing: border-box;
    }
    .points{
      width: 100%;
      padding:  0 352px 0 45px;
      box-sizing: border-box;
      height: 292px;
      overflow: auto;
    }
    .points::-webkit-scrollbar {
      display: none
    }
    .points-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px dashed #B2B2B2;
    }
    .points-item>div:nth-of-type(1)>p:nth-of-type(1){
      font-size: 13px;
      color: #3A3A3A;
      font-weight: bold;
    }
    .points-item>div:nth-of-type(1)>p:nth-of-type(2){
      font-size: 12px;
      color: #9E9E9E;

    }
    .point-top{
      width: 100%;
      height: 210px;
      background-image: url(../../static/image/userinfo/points.png);
      background-size: 100%;
      box-sizing: border-box;
      position: relative;
      // display: flex;
      // align-items: center;
    }
    .point-top>div:nth-of-type(1){
      width: 130px;
      height: 130px;
      background-image: url(../../static/image/userinfo/circal.png);
      text-align: center;
      position: absolute;
      top:16%;
      left: 26%;
    }
     // .point-top>div:nth-of-type(1)>img{
     //   margin-left: 20%;
     //   margin-top: 4%;
     // }
    .point-top>div:nth-of-type(1)>p:nth-of-type(1){
        // position: absolute;
        // top:16%;
        // left: 26%;
        font-size: 34px;
        color: #DFB876;
        font-weight: bold;
        margin: 0;
        margin-top: 23%;
    }
    .point-top>div:nth-of-type(1)>p:nth-of-type(2){
        // position: absolute;
        // top:47%;
        // left:27%;
        font-size: 15px;
        color: #DFB876;

    }
     .point-top>div:nth-of-type(2){
       // margin-left: 17px;
       position: absolute;
       left: 17px;
       bottom: 28px;
       font-size: 12px;
       color: #3A3A3A;
       display: flex;
       align-items: center;
     }
     .point-top>div:nth-of-type(2)>span{
       // position: absolute;
       // left: 3px;
       // bottom: 22px;
      margin-right: 3px;
     }
</style>



// WEBPACK FOOTER //
// src/components/myPoints.vue